/**
 * Skeleton Card — shimmer loading placeholder.
 * NOT a spinner. Premium dashboards use shimmer for perceived performance.
 */
export default function SkeletonCard() {
  return (
    <div className="rounded-[14px] bg-surface border border-white/[0.06] p-5">
      {/* Title skeleton */}
      <div
        className="h-5 w-3/4 rounded-md shimmer-bg"
      />
      {/* Stats row skeleton */}
      <div className="flex gap-3 mt-4">
        <div
          className="h-3 w-16 rounded-full shimmer-bg"
          style={{ animationDelay: '100ms' }}
        />
        <div
          className="h-3 w-20 rounded-full shimmer-bg"
          style={{ animationDelay: '200ms' }}
        />
      </div>
      {/* Progress bar skeleton */}
      <div
        className="h-2 w-full rounded-full shimmer-bg mt-4"
        style={{ animationDelay: '300ms' }}
      />
    </div>
  )
}

export function SkeletonMetricCard() {
  return (
    <div className="rounded-[14px] bg-surface border border-white/[0.06] p-4">
      <div className="h-10 w-16 shimmer-bg rounded-md mb-2" />
      <div className="h-3 w-20 shimmer-bg rounded-full" style={{ animationDelay: '100ms' }} />
    </div>
  )
}

export function SkeletonHealthBar() {
  return (
    <div className="glass rounded-[14px] px-6 py-4 flex items-center justify-between">
      <div className="flex gap-5">
        {[1,2,3].map(i => (
          <div key={i} className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full shimmer-bg" />
            <div className="h-3 w-12 shimmer-bg rounded-full" style={{ animationDelay: `${i * 80}ms` }} />
          </div>
        ))}
      </div>
      <div className="h-3 w-16 shimmer-bg rounded-full" style={{ animationDelay: '300ms' }} />
    </div>
  )
}
